module.exports = __webpack_public_path__ + "static/media/blog.c1b49abb.png";